<template>
    <div v-if="componentShow">
        <simple-table v-model="noObj.type" :table-name="tableName" :clearable=false :filter-data="filterData"
                      class="nosimple"></simple-table>
        <el-container>
            <el-aside width="calc(100% - 27px)">
                <el-input type="textarea" resize="none" :rows="rows" v-model="noObj.no"  ref="zmnoinput"
                          :class="{'no1': rows <= 1,'no2' : rows == 2 ,'no3': rows == 3,'no4' : rows == 4,'no5' : rows == 5 ,'no6' : rows == 6 ,'noelse' : rows > 6}"  class="noinput"
                          :style="{height: btHeight}" style="margin-top: -2px;overflow: hidden;
                        border-bottom: 1px solid #dcdfe6; border-bottom-left-radius: 4px;"></el-input>
            </el-aside >
            <el-main style="overflow: hidden">
                <el-button :style="{height: btHeight}" v-if="rows == 1" style="padding: 6px;overflow: hidden;
          border-left: 0px;margin-top: -2px;border-bottom-left-radius: 0px;border-bottom-right-radius: 4px;" @click="emptyValue">{{$t(i18nPage+'清')}}</el-button>
                <el-button :style="{height: btHeight}" v-else style="padding: 6px;overflow: hidden;
          border-left: 0px;margin-top: -2px;border-bottom-left-radius: 0px;border-bottom-right-radius: 4px;" @click="emptyValue">{{$t(i18nPage+'清')}}<br/>{{$t(i18nPage+'空')}}</el-button>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import ElAside from "element-ui/packages/aside/src/main";

    export default {
        beforeCreate() {
            this.i18nPage = 'component.ZmNo.';
        },
        components: {ElAside},
        name: "ZmNo",
        props: {
            rows:{
                type:Number,
                default:3
            },
            tableName:{
                type:String,
                required:true
            },
            defaultType:{
                type:String
            },
            maxRow:{
                type:Number,
                default:300
            },
            filterData:{
                type:Function
            },
            maxRowData:{
                type:Object
            }
        },
        data(){
            return {
                i18nPage : 'component.ZmNo.',
                noObj:{
                    type:'',
                    no:'',
                },
                componentShow:true
            }
        },
        watch: {
            newValue(nval,oval) {
                if(nval){
                    let that = this;
                    let vals = nval.split("\n");
                    let length = vals.length;
                    if(length > 0){
                        if(!vals[length-1]){
                            length = length -1;
                        }
                    }
                    let mxr = this.maxRow;
                    if(this.maxRowData){
                        if(this.maxRowData[this.noObj.type]){
                            mxr = this.maxRowData[this.noObj.type];
                        }
                    }
                    if(length > mxr) {
                        this.$util.show(this.$t(this.i18nPage+'单号不能超过') + mxr + this.$t(this.i18nPage+'个'), 1);
                        setTimeout(() => {
                            that.noObj.no = oval;
                        }, 10)
                    }
                }
                /*if(nval){
                    let that = this;
                    let length = nval.split("\n").length;
                    if(length > this.maxRow) {
                        this.$util.show('单号不能超过' + this.maxRow + '个', 1);
                        setTimeout(() => {
                            that.noObj.no = oval;
                        }, 10)
                    }
                }*/
            }
        },
        computed:{
            newValue(){
                return this.noObj.no;
            },
            btHeight(){
                if(this.rows <= 1){
                    return '33px';
                }else if(this.rows == 2 ){
                    return '54px';
                }else if(this.rows == 3){
                    return '75px';
                }else if(this.rows == 4){
                    return '96px';
                }else if(this.rows == 5){
                    return '117px';
                }else if(this.rows == 6){
                    return '138px'
                }else{
                    return '159px';
                }
            }
        },
        methods: {
            getValue(){
                return this.noObj;
            },
            emptyValue(){
                this.noObj.no = '';
                this.$refs['zmnoinput'].focus()
            },
            select(){
                this.$refs['zmnoinput'].select()
            }
        },
        created(){
            if(this.defaultType){
                this.noObj.type = this.defaultType;
            }
        },
        beforeDestroy(){
            this.componentShow = false
        }
    };
</script>

<style>

    .nosimple .el-input__inner{
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 0px;
    }

    .noinput .el-textarea__inner{
        border-bottom-right-radius: 0px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        padding: 5px 15px !important;
        font-size: inherit !important;
        border-bottom: 0px;
    }

    .no1 .el-textarea__inner{ height: 33px; }
    .no2 .el-textarea__inner{ height: 54px; }
    .no3 .el-textarea__inner{ height: 75px; }
    .no4 .el-textarea__inner{ height: 96px; }
    .no5 .el-textarea__inner{ height: 117px; }
    .no6 .el-textarea__inner{ height: 138px; }
    .noelse .el-textarea__inner{ height: 159px; }
</style>


// WEBPACK FOOTER //
// src/components/ZmNo/index.vue